import React, { useEffect, useState, useRef } from 'react';
import './ImageGrid.css';
import ImageCard from './ImageCard';

function ImageGrid({ images, onImageClick }) {
  const [loadedImages, setLoadedImages] = useState([]);
  const cacheRef = useRef(new Set());

  // Preload all images at once and store in cache
  const preloadImages = async (images) => {
    if (!Array.isArray(images)) return [];
    const results = [];
    await Promise.all(
      images.map((image) => {
        return new Promise((resolve) => {
          const src = image.thumbSrc || image.src;
          if (cacheRef.current.has(src)) {
            results.push(image);
            resolve();
            return;
          }
          const img = new window.Image();
          img.src = src;
          img.onload = img.onerror = () => {
            cacheRef.current.add(src);
            results.push(image);
            resolve();
          };
        });
      })
    );
    return results;
  };

  useEffect(() => {
    let isMounted = true;
    preloadImages(images).then((preloaded) => {
      if (isMounted) setLoadedImages(preloaded);
    });
    return () => {
      isMounted = false;
    };
  }, [images]);

  if (loadedImages.length === 0) {
    return <div className="loading-spinner"></div>;
  }

  return (
    <div className="image-grid">
      {loadedImages.map((image, idx) => (
        <ImageCard
          key={idx}
          image={image}
          onClick={() => onImageClick(image)}
          cache={cacheRef.current}
        />
      ))}
    </div>
  );
}

export default ImageGrid;